import { MenuBookOutlinedIcon, NoRowsOverlay } from '@shared/components';

export default function HomePage() {
  return (
    <NoRowsOverlay
      title='Hello there, Welcome to exam-center 👋'
      description=''
      icon={MenuBookOutlinedIcon}
      slotProps={{
        icon: {
          fontSize: 100,
          color: 'primary',
        },
      }}
    />
  );
}
